import Icon, { ICONS } from "components/common/Icons";
import BottomModal from "components/common/Modal/BottomModal";
import Button from "components/common/buttons/buttons";
import { t } from "i18next";
import { useTranslation } from "next-i18next";
import { TYPO } from "styles/Typo";
import useModalClickOutside from "utils/useModalClickOutside";

const PriceForecastExplainModal = ({ setModal, isModalOpen }: any) => {
  const modalRef = useModalClickOutside(setModal); // 모달 참조를 위한 ref 추가

  const { t } = useTranslation("detail");

  return (
    <BottomModal
      isOpen={isModalOpen}
      modalRef={modalRef}
      containerClass={`gap-4 !pb-9`}
    >
      <div className="flex flex-col gap-4">
        <h3 className={`${TYPO.TYPO4_B} text-gray80`}>
          {t("whatIspriceChangeForecast")}
        </h3>
        <div>
          <span className={`break-keep ${TYPO.TYPO5_1_MD}  text-gray60`}>
            {t("priceForecastDesc1")}
          </span>
          <span className={`break-keep ${TYPO.TYPO5_1_SB} text-gray70`}>
            {t("bestCase")}
          </span>
          <span className={`break-keep ${TYPO.TYPO5_1_MD}  text-gray60`}>
            {t("priceForecastDesc2")}
          </span>
          <span className={`break-keep ${TYPO.TYPO5_1_SB} text-gray70`}>
            {t("worstCase")}
          </span>
          <span className={`break-keep ${TYPO.TYPO5_1_MD}  text-gray60`}>
            {t("priceForecastDesc3")}
          </span>
        </div>
      </div>
      <div className="px-6 py-[18px] flex flex-col gap-[5px] bg-gray2 rounded-[16px] w-full">
        <p className={`${TYPO.TYPO7_1_SB} text-gray80`}>
          {t("priceForecastSubDescTitle")}
        </p>
        <span className={`${TYPO.TYPO7_1_RG} text-gray60`}>
          {t("priceForecastSubDesc")}
        </span>
      </div>
      <Button
        type={"primary"}
        size={"lg"}
        text={t("confirm")}
        clickHandler={() => setModal(false)}
        width="w-full"
      />
    </BottomModal>
  );
};

export default PriceForecastExplainModal;
